export default {
  id: 116,
  title: 'Target #116 - Headphones',
  url: 'https://cssbattle.dev/play/116',
  colors: ['#293D7E', '#6E91CA'],
  solution:
    '<p a><p b><style>[a],[b]{left:115}body{background:#293d7e}p{position:fixed}[a]{top:149;width:60;height:80;border-radius:60px 60px 1in 1in;background:#6e91ca;box-shadow:110px 0 #6e91ca}[b]{top:29;width:130;height:120;border-radius:9in 9in 0 0;border:20px solid #6e91ca;border-bottom:none}</style>',
}
